import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';

import { VersionCheckService } from '@shared/services/version-check.service';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Router } from '@angular/router';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private _platform = inject(Platform);
  private _versionCheckService = inject(VersionCheckService);
  private _router = inject(Router);

  constructor() {
    this._platform
        .ready()
        .then(async () => {
          this._versionCheckService.check();

          if (!Capacitor.isNativePlatform()) {
            return;
          }

          await StatusBar.setStyle({ style: Style.Light });

          await App.addListener('backButton', ({ canGoBack }) => {
            if (!canGoBack) {
              App.exitApp();
            } else {
              window.history.back();
            }
          });

          await App.addListener('appStateChange', () => {
            //
          });

          await App.addListener('appUrlOpen', this._handleAppUrlOpen.bind(this));

        });
  }

  private async _handleAppUrlOpen(event: URLOpenListenerEvent) {

    const apiHost = new URL(environment.apiHost).host;
    const path = event.url
                      .split(apiHost)
                      .pop();
    if (!path) {
      // If no match, do nothing - let regular routing logic take over
      return;
    }
    await this._router.navigateByUrl(path);
  }
}
